const shouldReadBodyAsJson = (statusCode) =>
    (statusCode >= 200 && statusCode <= 299) ||
    statusCode === 400 ||
    statusCode === 307;

export const GetJson = (url) => {
    return fetch(url, { redirect: "follow" }).then((r) => {
        if (!shouldReadBodyAsJson(r.status)) {
            return new Promise((resolve, reject) => {
                resolve({
                    status: r.status,
                    headers: r.headers,
                    data: { widgets: [] },
                });
            });
        }
        return r.json().then((data) => ({ status: r.status, data }));
    });
};

export const RequestJson = (url, method, body) => {
    return fetch(url, {
        method: method,
        headers: {
            "Content-Type": "application/json",
        },
        body: body ? JSON.stringify(body) : null,
        redirect: "follow",
    }).then((r) => {
        if (!shouldReadBodyAsJson(r.status)) {
            return new Promise((resolve, reject) => {
                resolve({
                    status: r.status,
                    headers: r.headers,
                    data: { widgets: [] },
                });
            });
        }
        return r.json().then((data) => ({ status: r.status, data }));
    });
};

const buildPaths = (path, routeParams) => {
    var finalPath = path;
    for (var value of Object.keys(routeParams)) {
        finalPath = finalPath.replace(`{{${value}}}`, routeParams[value]);
    }

    const urlSearchParams = new URLSearchParams(window.location.search);
    for (const [key, value] of urlSearchParams) {
        finalPath = finalPath.replace(`{{${key}}}`, value);
    }

    finalPath = finalPath.replace(/{{.*?}}/, "");

    return finalPath;
};

export const GetWidgetResponse = (path, routeParams, method, body) => {
    const fullUrl = buildPaths(path, routeParams);
    var fetchTask = method
        ? method === "GET"
            ? GetJson(fullUrl)
            : RequestJson(fullUrl, method, body)
        : GetJson(fullUrl);

    return fetchTask
        .then(({ status, headers, data }) => {
            if (status === 404) {
                window.location = window.Spa.NotFoundUrl;
            } else if (status === 401) {
                window.location = data.loginUrl.replace(
                    "{0}",
                    encodeURIComponent(window.location.href)
                );
            } else if (status === 307) {
                window.location = data.url;
            }

            return Promise.resolve(data.widgets);
        })
        .catch((err) => {
            return Promise.reject(err);
        });
};
